import * as ResponsiveFns from '../utilities/ResponsiveFns';
import * as StyleFunctions from '../utilities/StyleFunctions';
import ScreenPieces from '../ScreenComponents/ScreenPieces';
import TabPagesFn from '../Tabs/TabPagesFn';
import React, {useRef} from 'react';

function App(props) {

  var width = props.width;
  var height = props.height;
  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var userNos = props.userNos;
  var userID = props.userID;

  var otherPeoplesPositions = props.otherPeoplesPositions;
  var updatesToPropagate = props.updatesToPropagate;
  var error = props.error;

  var tabSelected = props.tabSelected;
  var changeTab = props.changeTab;
  var isShowingSomeDropDown = props.isShowingSomeDropDown;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;

  var screenSize = props.screenSize;

  var setItemEdited = props.setItemEdited;
  var itemEdited = props.itemEdited;

  var refObject = props.refObject;
  var setRefObject = props.setRefObject;
  var isClickingOnContentDiv = props.isClickingOnContentDiv;
  var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
  var isFEOrPUShown = props.isFEOrPUShown;
  var whichFEOrPUShown = props.whichFEOrPUShown;

  var hidePanelRelativeItems = props.hidePanelRelativeItems;

  var translateX = props.translateX;
  var translateY = props.translateY;

  var otherInfo = props.otherInfo;
  var setOtherInfo = props.setOtherInfo;
  var addWhereText = props.addWhereText;
  var inputValues = props.inputValues;
  var screenRefs = props.screenRefs;
  var flashHighlight = props.flashHighlight;
  var setScreenRefs = props.setScreenRefs;
  var potentiallyAddWhichItem = props.potentiallyAddWhichItem;
  var screenSelectionChoices = props.screenSelectionChoices;
  var setScreenSelectionChoices = props.setScreenSelectionChoices;
  var setInputValues = props.setInputValues;
  var highlightAnItem = props.highlightAnItem;
  var addPanel = props.addPanel;
  var setBaselineMousePosition = props.setBaselineMousePosition;
  var urlParamsForExecution = props.urlParamsForExecution;
  var reportPageHeight = props.reportPageHeight;
  var thisFE = props.thisFE;
  var scale = props.scale;
  var offsetTop = props.offsetTop;
  var offsetLeft = props.offsetLeft;
  var chains = props.chains;
  var lastEdited = props.lastEdited;
  var counter = props.counter;

  var fe = currentList.fe;
  var feKeys = Object.keys(fe);


  var ssSizes = StyleFunctions.screenWidthsAndHeights(screenSize);
  var insetWidth = ssSizes.insetWidth;
  var insetHeight = ssSizes.insetHeight;
  var urlHeader = 'https://www.cues.sg/dapps/XXXX';


  var getRef1 = function(refIn){
    setRefObject({...refIn});
  }

  var pageRef1 = useRef();


  var offsetTop1 = 0;
  var offsetLeft1 = 0;

  if (pageRef1 && pageRef1.current){
    offsetTop1 = (offsetTop / scale) + pageRef1.current.offsetTop;
    offsetLeft1 = (offsetLeft / scale) + pageRef1.current.offsetLeft;
  }
//  

  var onClickItemChangeSelection = StyleFunctions.onClickItemChangeSelectionFn(setItemEdited, setIsShowingSomeDropDown);
  var internalVariables = StyleFunctions.getInternalVariables(otherInfo, setOtherInfo, {t:isFEOrPUShown, v:whichFEOrPUShown});
  var ownVariables = StyleFunctions.getOwnVariableDefaultValues(currentList, internalVariables, width, height, urlParamsForExecution, urlHeader, chains);

  var classNameBottomBit = 'btn btn-secondary';
  if (highlightAnItem && highlightAnItem.t === 'withinPage' && highlightAnItem.v === '+ Panel'){
    classNameBottomBit = 'btn btn-outline-primary'
  }
  var bottomBit = <button className={classNameBottomBit} onClick={addPanel(isFEOrPUShown, whichFEOrPUShown)} style={{marginTop:'20px', marginBottom:'20px'}}>+ Panel</button>
//  
  var actWidth = insetWidth;
  var screenWidth = actWidth;

  var backgroundColor;

  var border = '1px solid black';
  var plusWidth = 2;

  if (itemEdited && itemEdited.t === 'page' && itemEdited.path.join(' ') === isFEOrPUShown + ' ' + whichFEOrPUShown){
    border = '8px solid yellow';
    plusWidth = 16;
  }
  // if (whichFEOrPU.v === aFEKey && isFEOrPU === whichFEOrPU.t){
  //   pageClassName = 'pageSelected';
  // }else{
  //   if (error && error.loc){
  //     if (error.loc[0] === isFEOrPU && error.loc[1] === aFEKey){
  //       divStyle.border = '2px solid red';
  //     }
  //   }      
  // }

  var s1 = {width:insetWidth + plusWidth, border, minHeight:insetHeight + plusWidth};

  if (isFEOrPUShown === 'pu'){
    s1.overflow = 'scroll';
    s1.maxHeight = insetHeight;
    s1.maxWidth = insetWidth;

    var puV = whichFEOrPUShown;
    var upwardInfo = [];
    var pageS = StyleFunctions.evaluateStyleR('PAGE', currentList.pu[puV].s, ['pu', puV, 's'], currentList, internalVariables, insetWidth, insetHeight, upwardInfo, inputValues, ownVariables, urlParamsForExecution, chains);
    backgroundColor = StyleFunctions.combineRGBAndOpacity(pageS.backgroundColor, pageS.paddingOpacity);
    screenWidth = ResponsiveFns.resolveSingular(pageS.w, insetWidth, insetHeight);
  }

  var scr = <ScreenPieces chains={chains} actualWidth={screenWidth} insetWidth={insetWidth} insetHeight={insetHeight} currentList={currentList} scale={scale} organicChanges={organicChanges} itemEdited={itemEdited} setItemEdited={setItemEdited} whichFEOrPU={{t:isFEOrPUShown, v:whichFEOrPUShown}} onClickItemChangeSelection={onClickItemChangeSelection} otherPeoplesPositions={otherPeoplesPositions} internalVariables={internalVariables} updatesToPropagate={updatesToPropagate} error={error} refObject={refObject} getRef1={getRef1} inputValues={inputValues} setInputValues={setInputValues} ownVariables={ownVariables} alertVisibility={{}} interactionFn={false} setIsShowingSomeDropDown={setIsShowingSomeDropDown} isShowingSomeDropDown={isShowingSomeDropDown} bottomBit={bottomBit} style={s1} className='' userNos={userNos} userID={userID} setIsClickingOnContentDiv={setIsClickingOnContentDiv} isClickingOnContentDiv={isClickingOnContentDiv} screenRefs={screenRefs} setScreenRefs={setScreenRefs} addWhereText={addWhereText} potentiallyAddWhichItem={potentiallyAddWhichItem} changeTab={changeTab} tabSelected={tabSelected} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={setScreenSelectionChoices} popUps={[]} setPopUps={false} hidePanelRelativeItems={hidePanelRelativeItems} flashHighlight={flashHighlight} urlParamsForExecution={urlParamsForExecution} reportPageHeight={reportPageHeight} overallWidth={width} offsetLeft={offsetLeft1} offsetTop={offsetTop1} urlHeader={urlHeader} lastEdited={lastEdited} counter={counter}/>

  var ins1;

  if (isFEOrPUShown === 'pu'){
    ins1 = <table style={{position:'relative', height:insetHeight,width:insetWidth, verticalAlign:'middle', border:'1px solid black', backgroundColor}}><tbody><tr><td>{scr}</td></tr></tbody></table>
//
  }else{
    ins1 = scr;
  }

  var pos = thisFE.pos;
  var pushX = 0;
  var pushY = 0;
  if (pos){
    pushX = pos.xP * insetWidth * 1.1;
    pushY = pos.yP * insetHeight * 1.1;
  }

  function clickPage(e){
    setItemEdited({t:'page', path:[isFEOrPUShown, whichFEOrPUShown]});
    e.stopPropagation();
  }

  var s = {position:'absolute', left:pushX + translateX - actWidth/2, top:pushY + translateY, zIndex:0};
  return <div style={s} onClick={clickPage} ref={pageRef1}>
    <TabPagesFn currentList={currentList} organicChanges={organicChanges} setItemEdited={setItemEdited} isFEOrPU={isFEOrPUShown} feKeys={feKeys} aFEKey={whichFEOrPUShown} setBaselineMousePosition={setBaselineMousePosition} error={error} flashHighlight={flashHighlight}/>{ins1}
    </div>
//
}


export default App;
